import React from 'react';

import { sendClickEvent } from '@/utils/AnalyticsUtils';
import { MenuIcon } from '@/assets/icons';
import { MOBILE_MENU_CLICKED, TEST_IDS } from '@/constants';

import styles from './TopNavbar.module.scss';

export interface ITopNavbarProps {
	isSideBarVisible?: boolean;
	toggleSidebarMobile: () => void;
}

const TopNavbar = (props: ITopNavbarProps) => {
	const { isSideBarVisible, toggleSidebarMobile } = props;

	const handleMenuClick = () => {
		sendClickEvent({
			name: MOBILE_MENU_CLICKED,
			value: isSideBarVisible ? 'opened' : 'closed',
		});
		toggleSidebarMobile();
	};

	return (
		<div className={styles.container} data-id={TEST_IDS.TOP_NAVBAR.CONTAINER}>
			<MenuIcon
				data-id={TEST_IDS.TOP_NAVBAR.MOBILE_NAVBAR_BTN}
				onClick={handleMenuClick}
				className={styles.menuIcon}
			/>
		</div>
	);
};

export default TopNavbar;
